import React from "react";
import { ClearFloat, Image, TextNode as RPDFCTextNode } from "@surge-global-engineering/react-pdf-components";
import { StyleSheet, View } from "@surge-global-engineering/rpdf-renderer";
import { PdfTheme } from "../types";
import { ADDITIONAL_FONT_SIZE_TO_ORNAMENTAL_BREAK, ORNAMENTALBREAK_MARGIN_BOTTOM, ORNAMENTALBREAK_MARGIN_TOP } from "../configs";

interface OrnamentalBreakProps {
    theme: PdfTheme;
    lightText?: boolean;
}

const OrnamentalBreak: React.FC<OrnamentalBreakProps> = ({ theme, lightText = false }) => {
    const { ornamentalBreakImage, baseFontSize, sceneBreakShowSetting } = theme.properties;

    const shouldBreakIfLastOnPage = theme?.properties.dynamicPageBreaks?.breakOrnamentalBreaks;

    const styles = StyleSheet.create({
        image: {
            width: `${theme.properties.ornamentalBreakWidth}%`,
            alignSelf: "center"
        },
        container: {
            textAlign: "center",
            marginTop: ORNAMENTALBREAK_MARGIN_TOP,
            marginBottom: ORNAMENTALBREAK_MARGIN_BOTTOM,
        }
    });

    const getImageUrl = () => {
        if (lightText) {
            // eslint-disable-next-line no-useless-escape
            const regx = /^(.*)Black\-(.*)$/g;
            if (regx.test(ornamentalBreakImage)) {
                return ornamentalBreakImage.replace("Black", "White");
            }
        }
        return ornamentalBreakImage;
    };

    if (sceneBreakShowSetting === "break-with-image") {
        if (ornamentalBreakImage) {
            return (
                <>
                    <ClearFloat />
                    <View style={styles.container} breakIfLastOnPage={shouldBreakIfLastOnPage}>
                        <Image src={getImageUrl()} style={styles.image} alignment="center" />
                    </View>
                </>
            );
        }

        return (
            <>
                <ClearFloat />
                <View style={styles.container} breakIfLastOnPage={shouldBreakIfLastOnPage}>
                    <RPDFCTextNode fontSize={baseFontSize + ADDITIONAL_FONT_SIZE_TO_ORNAMENTAL_BREAK}>***</RPDFCTextNode>
                </View>
            </>
        );
    } else {
        return (
            <>
                <ClearFloat />
                <View style={styles.container} breakIfLastOnPage={shouldBreakIfLastOnPage}>
                    <RPDFCTextNode fontSize={baseFontSize + ADDITIONAL_FONT_SIZE_TO_ORNAMENTAL_BREAK}></RPDFCTextNode>
                </View>
            </>
        );
    }

};

export default OrnamentalBreak;